import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "56bdcc4db1882f5196d485821c72efca.png","uri@3x": __webpack_public_path__ + "6314814000e7fcd47fa146b8735d51a3.png","uri@2x": __webpack_public_path__ + "56bdcc4db1882f5196d485821c72efca.png",
    width: 656,
    height: 83
});